// extracted by mini-css-extract-plugin
export default {"vatMessage":"YKyMh"};